import { Injectable } from '@angular/core';
import { CommunicationsLogListBuilder } from '../builders/communications-log-list-builder';
import { CommunicationsLogBuilder } from '../builders/communications-log-builder';
import { AuthenticatedApiService } from './authenticated-api.service';
import * as i0 from "@angular/core";
import * as i1 from "./authenticated-api.service";
export class CommunicationsLogsApiService {
    constructor(api) {
        this.api = api;
    }
    getCommunicationsLog(id) {
        return this.api.get(`/communicationslogs/reservation/${id}`).toPromise().then(response => {
            return response['communications_log'].map(log => {
                return CommunicationsLogBuilder.buildCommunicationsLog(log);
            });
        });
    }
    getCommunicationsLogList(params) {
        let payload = Object.assign({}, params);
        return this.api.get('/communicationslogs/list', payload)
            .toPromise().then(response => {
            return CommunicationsLogListBuilder.buildCommunicationsLogList(response);
        });
    }
}
CommunicationsLogsApiService.ɵfac = function CommunicationsLogsApiService_Factory(t) { return new (t || CommunicationsLogsApiService)(i0.ɵɵinject(i1.AuthenticatedApiService)); };
CommunicationsLogsApiService.ɵprov = i0.ɵɵdefineInjectable({ token: CommunicationsLogsApiService, factory: CommunicationsLogsApiService.ɵfac });
(function () { i0.ɵsetClassMetadata(CommunicationsLogsApiService, [{
        type: Injectable
    }], function () { return [{ type: i1.AuthenticatedApiService }]; }, null); })();
//# sourceMappingURL=communications-logs-api.service.js.map